var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c("div", { staticClass: "cabin-footer__wrapper" }, [
      _c("div", { staticClass: "cabin-footer__second" }, [
        _setup.is("tariff")
          ? _c("div", { class: `${_setup.baseClass}__line` }, [
              _c("div", { class: `${_setup.baseClass}__name` }, [
                _vm._v("Тариф"),
              ]),
              _vm._v(" "),
              _c("div", { class: `${_setup.baseClass}__value` }, [
                _c("strong", [
                  _vm._v(
                    _vm._s(_setup.show_price("tariff")) +
                      "\n                        "
                  ),
                  _c("span", [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_setup.symb("tariff")) +
                        "\n                        "
                    ),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _setup.is("dues")
          ? _c("div", { class: `${_setup.baseClass}__line` }, [
              _c("div", { class: `${_setup.baseClass}__name` }, [
                _vm._v("Сборы"),
              ]),
              _vm._v(" "),
              _c("div", { class: `${_setup.baseClass}__value` }, [
                _c("strong", [
                  _vm._v(
                    _vm._s(_setup.show_price("dues")) +
                      "\n                        "
                  ),
                  _c("span", [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_setup.symb("dues")) +
                        "\n                        "
                    ),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cabin-footer__main",
          on: { click: _setup.toggleHidden },
        },
        [
          _c("div", { class: `${_setup.baseClass}__line` }, [
            _c("div", { class: `${_setup.baseClass}__name` }, [
              _vm._v("Итого:"),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { class: `${_setup.baseClass}__value` },
              [
                _vm.precalc && _vm.precalc.calc.wait
                  ? [_c(_setup.Loader, { staticClass: "cp-loader" })]
                  : _vm.precalc && _vm.precalc.calc.ok && _vm.precalc.calc.acc
                  ? [
                      _c("strong", [
                        _vm._v(
                          _vm._s(_setup.show_price("v")) +
                            "\n                            "
                        ),
                        _c("span", { attrs: { title: _setup.title() } }, [
                          _vm._v(
                            "\n                                " +
                              _vm._s(_setup.symb("v")) +
                              "\n                            "
                          ),
                        ]),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "cabin-footer__hidden",
        class: { _active: _setup.isHiddenActive },
      },
      [
        _setup.is("comm")
          ? _c("div", { class: `${_setup.baseClass}__line` }, [
              _c("div", { class: `${_setup.baseClass}__name` }, [
                _vm._v("Комиссия " + _vm._s(_setup.show_pcomm())),
              ]),
              _vm._v(" "),
              _c("div", { class: `${_setup.baseClass}__value` }, [
                _c("strong", [
                  _vm._v(
                    _vm._s(_setup.show_price("comm")) +
                      " " +
                      _vm._s(_setup.symb("comm"))
                  ),
                ]),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _setup.is("comm")
          ? _c("div", { class: `${_setup.baseClass}__line` }, [
              _c("div", { class: `${_setup.baseClass}__name` }, [
                _vm._v("К оплате агентом"),
              ]),
              _vm._v(" "),
              _c("div", { class: `${_setup.baseClass}__value` }, [
                _c("strong", [
                  _vm._v(
                    _vm._s(_setup.show_agent_sum()) + "\n                    "
                  ),
                  _c("span", [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_setup.symb("comm")) +
                        "\n                    "
                    ),
                  ]),
                ]),
              ]),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }